import axios from "axios";
import qs from "qs";

export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});
export const apiCedula = axios.create({
  //baseURL: process.env.VUE_APP_BASE_URL_MAIL
});
export default {
  login(user) {
    return apiClient.post("/login", user);
  },
  logout(user) {
    return apiClient.post("/logout", user);
  },
  getUsers(payload) {
    if (payload.data) {
      return apiClient.get("/users", {params:payload.data});
    }else {
      return apiClient.get("/users");
    }
    // return apiClient.get("/users");
  },
  getUser(id) {
    return apiClient.get("/users/" + id);
  },
  addUser(dataUser) {
    return apiClient.post("/signup", dataUser);
  },
  editUser(dataUser) {
    return apiClient.put("/users/edit", dataUser);
  },
  deleteUser(id) {
    return apiClient.delete("/users/delete/" + id);
  },
  updatePassword(data) {
    return apiClient.put("/users/updatePassword", data);
  },

  // ROLES
  selectRoles() {
    return apiClient.get("/selectroles");
  },

  getRoles() {
    return apiClient.get("/roles");
  },
  getRole(id) {
    return apiClient.get("/roles/" + id);
  },
  addRole(dataRole) {
    return apiClient.post("/roles/new", dataRole);
  },
  editRole(dataRole) {
    return apiClient.put("/roles/edit", dataRole);
  },
  deleteRole(id) {
    return apiClient.delete("/roles/delete/" + id);
  },

  // PARTES
  consultarParte(data) {
    return apiClient.get("/partes", { params: data });
  },
  getParte(id) {
    return apiClient.get("/partes/" + id);
  },
  addParte(dataParte) {
    //apiClient.defaults.headers.common["Authorization"] = "Bearer " + dataParte.token;
    return apiClient.post("/partes/new", dataParte);
  },
  editParte(dataParte) {
    return apiClient.put("/partes/update", dataParte);
  },
  // deleteParte(id) {
  //   return apiClient.delete("/partes/" + id);
  // },
  deleteParteToca(data) {
    return apiClient.put("/partes/eliminar",data);
  },
  getTocasByParte(id, page = 1) {
    return apiClient.get("/partes/"+id+"/tocas", {
      params: { page }
    });
  },
  addMultplieTocasToParte(data) {
    return apiClient.post("/partes/"+data.parte_id+"/add-tocas", data.tocas);
  },

  // NOTIFICACIONES
  getNotificaciones(data) {
    let params = {
      'parte_id' : data.pivot.parte_id,
      'toca_id': data.pivot.toca_id
    };
    return apiClient.get("/notificaciones",{ params: params });
  },
  saveNotificacion(notificacion) {
    // apiClient.defaults.headers.common["Authorization"] = "Bearer " + notificacion.token;
    return apiClient.post("/notificaciones/new", notificacion);
  },
  sendNotificacion(dataNotificacion) {
    return apiClient.post("/send-notification", dataNotificacion);
  },
  generateAcuse(notificacion_id,tipo) {
    return apiClient.get("notificaciones/" + notificacion_id + "/pdf", {
      responseType: "arraybuffer",
      params: {tipo: tipo}
    });
  },
  getFile(data) {
    return apiClient.get("notificaciones/" + data + "/file", {
      responseType: "arraybuffer"
    });
  },
  //Salas
  getSalas() {
    return apiClient.get("/salas");
  },
  getTotalesBySala() {
    return apiClient.get("/totales");
  },

  //CEDULAS
  getTokenCedula(user) {
    return apiCedula.post("http://cedulas.test/login", user);
  },
  consultarCedula(data) {
    //apiCedula.defaults.headers.common["Authorization"] = "Bearer " + data.token;
    return apiClient.get("/cedulas", { params: data });
  },
  // consultarCedula(data) {
  //   apiCedula.defaults.headers.common["Authorization"] = "Bearer " + data.token;
  //   return apiCedula.get("http://cedulas.test/cedulas", { params: data });
  // },

  //TOCAS
  addToca(toca) {
    return apiClient.post("/partes/"+toca.parte_id+"/toca", toca);
  },
  getTocas(data) {
    return apiClient.get("/tocas?page=" + data.current, { params: data });
  },
  getPartesByToca(data) {
    return apiClient.get("/tocas/" + data.toca_id + "/partes", { params: data });
  },
  showToca(parte_id) {
    return apiClient.get("/tocas/" + parte_id);
  },
  confirmToca(data) {
    return apiClient.post("/partes/" + data.parte_id + "/tocas", data );
  },
  cancelToca(data) {
    return apiClient.post("/partes/" + data.parte_id + "/tocas/" + data.toca_id, );
  },
  confirmAcuerdo(data) {
    return apiClient.post("/partes/" + data.parte_id + "/confirmar-acuerdo", data);
  },

  //LOGS
  getLogsPaginate(data) {
    return apiClient.get("/logs", { params: data });
  },

  getEstados(data) {
    return apiClient.get("/estados");
  },
  getMunicipios(estadoId) {
    return apiClient.get("/municipios/" + estadoId);
  }
};
